var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSection2Arrow = function SvgSection2Arrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 53.43 151.042",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#section2-arrow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.663 150.525C22.829 129.895 25.84 75 13.68 39.591L1.404 46.426 3.81 1.404l34.85 25.443-9.67 3.985s20.666 44.63 23.036 83.224",
    fill: "url(#section2-arrow_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.663 150.525C22.829 129.895 25.84 75 13.68 39.591L1.404 46.426 3.81 1.404l34.85 25.443-9.67 3.985s20.666 44.63 23.036 83.224",
    stroke: "var(--stroke-0, #D6D7DA)",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "section2-arrow_svg__b",
    x1: 36,
    y1: 130.542,
    x2: 6,
    y2: 1.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F8FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "section2-arrow_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.43v151.042H0z"
  })))));
};
export default SvgSection2Arrow;